import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import cx from 'classnames';
import { setMobileNavVisibility } from '../../reducers/Layout';
import { withRouter } from 'react-router-dom';

import Header from './Header';
import Footer from './Footer';
import SideBar from '../../components/SideBar';
/**
 * Pages
 */
import Home from '../Home';
import Dashboard from '../Dashboard';
import Teams from '../Teams';
import Schedule from '../Schedules';
import TeamStanding from '../TeamStanding';
import TopPerformers from '../TopPerformers';
import GameResults from '../GameResults';
import Scores from '../Scores';
import Rules from '../Rules';
import Upcoming from '../Upcoming';
import RegistrationNoPayment from '../Registration/indexNoPayment';
import Registration from '../Registration';
import ThankYou from '../ThankYou';
import Players from '../Players';

const Main = ({
  mobileNavVisibility,
  hideMobileMenu,
  history
}) => {
  history.listen(() => {
    if (mobileNavVisibility === true) {
      hideMobileMenu();
    }
  });
  return (
    <div className={cx({
      'nav-open': mobileNavVisibility === true
    })}>
      <div className="wrapper">
        <div className="close-layer" onClick={hideMobileMenu}></div>
        <SideBar />

        <div className="main-panel">
          <Header />
          
          <Route path="/home" component={Home} />
          <Route  path="/Dashboard" component={Dashboard} />
          {/* <Route path="/register" component={RegistrationNoPayment} /> */}
          {/* <Route path="/players" component={Players} /> */}
          <Route path="/scores" component={Scores} />
          <Route path="/teams" component={Teams} />
          <Route path="/schedule" component={Schedule} />
          <Route path="/teamtanding" component={TeamStanding} />
          <Route path="/top-performers" component={TopPerformers} />
          <Route path="/gameresults" component={GameResults} />
          <Route path="/rules" component={Rules} />
          <Route path="/upcoming" component={Upcoming} />
          <Route path="/thankyou" component={ThankYou} />
          <Route exact path="/" component={Scores} />
          <Footer />
        </div>
      </div>
    </div>
  )
};

const mapStateToProp = state => ({
  mobileNavVisibility: state.Layout.mobileNavVisibility
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  hideMobileMenu: () => dispatch(setMobileNavVisibility(false))
});

export default withRouter(connect(mapStateToProp, mapDispatchToProps)(Main));


// WEBPACK FOOTER //
// ./src/pages/Main/index.js